import { number, shape, string } from "prop-types";

const PositionType = shape({ lat: number, lng: number });

const MapMarkerType = shape({ position: PositionType, location: string });

export { PositionType, MapMarkerType };
